import uiReducer from 'app/modules/ui/actions';
import { STAGES } from 'app/modules/ui/constants';
import initialState from 'app/modules/ui/initialState';

export default uiReducer;

/*
 * selectors
 */

export const getIsVisible = state => {
  return state.isVisible;
};

export const getIsMinimized = state => {
  return state.isMinimized;
};

export const getminimizedAt = state => {
  return state.minimizedAt;
};

export const getStage = state => {
  return state.stage;
};

export const getCompositionDraft = state => {
  return state.compositionDraft;
};

export const getIsSupressedByRules = state => {
  return state.suppressedByRules;
};

export const getIsAutoShow = state => {
  return state.autoShowWidget;
};

export const getCurrentLocation = state => {
  const history = state.locationHistory;
  return history[history.length - 1];
};

export { initialState, STAGES };
